import React, { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import http from "../../../src/Redux/services/http-common.jsx";
import "./labcart.css";
import MembershipStatus from "./MembershipStatus.jsx";
import AddressBook from "./AddressBook.jsx";
import moment from "moment";

const LabCartPage = ({
  scheduledata,
  closeFun,
  isAddressAdded,
  selectedAddress,
  setSelectedAddress = () => {},
  setIsAddressAdded = () => {},
}) => {
  const [pincode, setPincode] = useState("");
  const [searchText, setSearchText] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [labCircle, setLabCircle] = useState("");
  const [cart, setCart] = useState([]);
  const [hospitalName, setHospitalName] = useState({
    labpartnername: "",
    labtestType: "",
    labstartTime: "",
    labEndTime: "",
  });
  
  const [isMembershipApplied, setIsMembershipApplied] = useState(false);
  const [totalcartsummary, setTotalcartsummary] = useState();
  const toast = React.useRef(null);
  const [cartId, setCartId] = useState();
  const [isVisible, setIsVisible] = useState(false);
  const [totalCartSummary, setTotalCartSummary] = useState({
    totalAmount: 0,
    paidAmount: 0,
  });
  const [locationid, setLocationid] = useState({
    locationId: "",
    hospitalname: "",
  });
  const [userName, setUserName] = useState("")

  useEffect(() => {
    let userData = JSON.parse(localStorage.getItem("userData"));
    console.log(userData?.code,"edrtghj")
    setUserName(userData?.code)
   
}, [userName])

 
  const [selectedDate, setSelectedDate] = useState(new Date()); 
  const [selectedTime, setSelectedTime] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Generate next 7 days for date selection
  const dates = Array.from({ length: 7 }, (_, i) => {
    const date = new Date();
    date.setDate(date.getDate() + i);
    return {
      date,
      label: i === 0 ? "Today" : i === 1 ? "Tomorrow" : date.toLocaleDateString("en-US", { weekday: "short" }),
      displayDate: date.toLocaleDateString("en-US", { month: "short", day: "numeric" }),
    };
  });





  const toDisplaySlot = (part) => {
    const match = part.match(/(\d{1,2})(?::(\d{2}))?\s*(AM|PM)/i);
    if (!match) {
      return part;
    }
    let hour = parseInt(match[1], 10);
    const modifier = match[3].toUpperCase();
    if (modifier === "AM" && hour === 12) {
      hour = 0;
    }
    if (modifier === "PM" && hour !== 12) {
      hour += 12;
    }
    return new Date(0, 0, 0, hour)
      .toLocaleTimeString("en-US", {
        hour: "2-digit",
        hour12: true,
      })
      .replace(":00", "");
  };

  const formatPreferredTimeForApi = (timeLabel = "") => {
    const parts = timeLabel.split(" - ");
    if (parts.length !== 2) {
      return timeLabel;
    }

    return `${toDisplaySlot(parts[0])} - ${toDisplaySlot(parts[1])}`;
  };

  const formatPreferredTimeDisplay = formatPreferredTimeForApi;

  const padHourLabel = (hour, useColon = true) => {
    const label = new Date(0, 0, 0, hour)
      .toLocaleTimeString("en-US", {
        hour: "2-digit",
        hour12: true,
      })
      .replace(":00", "");
    if (!useColon) {
      return label.replace(" ", "");
    }
    return label;
  };

  const generateTimeSlots = (selectedDate) => {
    let slots = [];
    const now = new Date();
    const currentHour = now.getHours();
    const disableUntil = currentHour + 4;
  
    if (!selectedDate) {
      selectedDate = new Date();
    }
  
    const today = now.toISOString().split("T")[0];
    const selectedDateString = selectedDate.toISOString().split("T")[0];
  
    for (let hour = 6; hour <= 18; hour++) {
      const startLabel = padHourLabel(hour);
      const endLabel = padHourLabel(hour + 1);
      const value = `${padHourLabel(hour, false)} - ${padHourLabel(hour + 1, false)}`;
  
      let isDisabled = false;
      if (selectedDateString === today) {
        isDisabled = hour < currentHour || hour < disableUntil;
      }
  
      slots.push({ time: value, label: `${startLabel} - ${endLabel}`, disabled: isDisabled });
    }
    return slots;
  };

  const generateTimeSlotsRadiology = (selectedDate, labstartTime, labEndTime) => {
    let slots = [];
  
    if (!labstartTime || !labEndTime) {
      return slots;
    }
  
    let startTime = new Date(`1970-01-01T${labstartTime}`);
    let endTime = new Date(`1970-01-01T${labEndTime}`);
    let now = new Date();
    let currentHour = now.getHours();
    let today = new Date().toISOString().split("T")[0];
    let selectedDateString = selectedDate.toISOString().split("T")[0];
  
    while (startTime < endTime) {
      let hour = startTime.getHours();
      const startLabel = padHourLabel(hour);
      const endLabel = padHourLabel(hour + 1);
      const value = `${padHourLabel(hour, false)} - ${padHourLabel(hour + 1, false)}`;
  
      let isDisabled = selectedDateString === today && hour <= currentHour;
  
      slots.push({ time: value, label: `${startLabel} - ${endLabel}`, disabled: isDisabled });
  
      startTime.setHours(startTime.getHours() + 1);
    }
  
    return slots;
  };
  

  // useEffect(() => {
  //   // Determine the initial date (e.g., today)
  //   const initialDate = new Date();
  
  //   // Generate available time slots for the initial date
  //   const availableTimeSlots =
  //     hospitalName?.labtestType === "Pathology"
  //       ? generateTimeSlots(initialDate)
  //       : generateTimeSlotsRadiology(
  //           initialDate,
  //           hospitalName?.labstartTime,
  //           hospitalName?.labEndTime
  //         );
  
  //   // Find the first available (non-disabled) time slot
  //   const firstAvailableSlot = availableTimeSlots.find(
  //     (slot) => !slot.disabled
  //   );
  
  //   // Set the initial selected date and time
  //   setSelectedDate(initialDate);
  //   setSelectedTime(firstAvailableSlot ? firstAvailableSlot.time : null);
  // }, [hospitalName]);
  
  

  useEffect(() => {
    if (scheduledata?.patientId) {
      fetchCartList();
    }
  }, [scheduledata?.patientId]);

  const fetchSuggestions = async (query, circle) => {
    try {
      // Get pincode from state, selectedAddress, or localStorage in that order
      const pinCode = pincode || selectedAddress?.pinCode || localStorage.getItem("selectedPinCode");
      
      if (!pinCode) {
        console.error("Pincode is not available");
        return;
      }

      const baseUrl = `${process.env.REACT_APP_DIAGNOSTICNEW}partner-labs/searchByName?pincode=${pinCode}&pageSize=10&filter=${query}`;

      const [packagesResult, nonPackagesResult] = await Promise.allSettled([
        http.get(`${baseUrl}&isPackage=true`),
        http.get(`${baseUrl}&isPackage=false`),
      ]);

      const flattenResponse = (apiResponse, fallbackIsPackage) => {
        const apiData = apiResponse?.data;
        const content = Array.isArray(apiData?.content) ? apiData.content : [];
        const flattened = [];

        content.forEach((entry) => {
          if (entry && typeof entry === "object") {
            Object.keys(entry).forEach((groupKey) => {
              const tests = entry[groupKey];
              if (Array.isArray(tests)) {
                tests.forEach((test) => {
                  flattened.push({
                    ...test,
                    groupKey,
                    isPackage:
                      test?.isPackage !== undefined
                        ? test.isPackage
                        : fallbackIsPackage,
                  });
                });
              }
            });
          }
        });

        return flattened;
      };

      const combined = [];
      if (packagesResult.status === "fulfilled") {
        combined.push(...flattenResponse(packagesResult.value, true));
      }
      if (nonPackagesResult.status === "fulfilled") {
        combined.push(...flattenResponse(nonPackagesResult.value, false));
      }

      const uniqueByKey = new Map();
      combined.forEach((item) => {
        const uniqueKey = [
          item?.labTestCode,
          item?.partnerTestCode,
          item?.cbTestCode,
          item?.id,
          item?.displayName,
          item?.name,
          item?.diagnosticsCode,
          item?.labId,
        ].filter(Boolean);
        const keyString = uniqueKey.join("|");
        const fallbackKey = [
          item?.displayName,
          item?.labTestName,
          item?.testName,
          item?.name,
          item?.diagnosticsName,
          item?.groupKey,
          item?.isPackage ? "pkg" : "test",
        ]
          .filter(Boolean)
          .join("|");
        const finalKey = keyString || fallbackKey || `item-${combined.length}`;

        if (!uniqueByKey.has(finalKey)) {
          uniqueByKey.set(finalKey, item);
        }
      });

      setSuggestions(Array.from(uniqueByKey.values()));
    } catch (error) {
      console.error("Error fetching suggestions:", error);
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchText(value);
    if (value.length > 2 && labCircle) {
      fetchSuggestions(value, labCircle);
    } else {
      setSuggestions([]);
    }
  };

  const checkServiceAvailability = async () => {
    if (!pincode) {
      toast.current.show({
        severity: "warn",
        summary: "Validation",
        detail: "Please enter a pincode.",
      });
      return;
    }

    try {
      const response = await http.get(
        `${process.env.REACT_APP_BASEURL}ServiceAvailability/checkDiagnoServiceAvailabilityCircle?pinCode=${pincode}`
      );
      const circle = response?.data;

      if (circle) {
        setLabCircle(circle);
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: `Service available for lab circle: ${circle}`,
        });
      } else {
        setLabCircle("");
        toast.current.show({
          severity: "info",
          summary: "Info",
          detail: "No lab circle available for this pincode.",
        });
      }
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Something went wrong while checking service availability.",
      });
    }
  };

  const selectSuggestion = (suggestion) => {
    setSearchText(suggestion.name);
    setSuggestions([]);
  };

  const formatCurrency = (amount) => {
    const numericValue = Number(amount) || 0;
    return Number.isInteger(numericValue)
      ? numericValue.toFixed(0)
      : numericValue.toFixed(2);
  };

  const normalizeLabTestData = (labTest = {}) => {
    const rawTestParameters = labTest?.testParameters;
    let testParameters = [];

    if (Array.isArray(rawTestParameters)) {
      testParameters = rawTestParameters
        .filter((param) => typeof param === "string" || typeof param === "number")
        .map((param) => String(param).trim())
        .filter((param) => param.length > 0);
    } else if (typeof rawTestParameters === "string") {
      testParameters = rawTestParameters
        .split(",")
        .map((param) => param.trim())
        .filter((param) => param.length > 0);
    }

    if (testParameters.length === 0) {
      const fallbackParameters =
        labTest?.componentCovered || labTest?.testParametersList || "";

      if (Array.isArray(fallbackParameters)) {
        testParameters = fallbackParameters
          .filter((param) => typeof param === "string" || typeof param === "number")
          .map((param) => String(param).trim())
          .filter((param) => param.length > 0 && param.toLowerCase() !== "na");
      } else if (typeof fallbackParameters === "string") {
        testParameters = fallbackParameters
          .split(",")
          .map((param) => param.trim())
          .filter(
            (param) =>
              param.length > 0 &&
              param.toLowerCase() !== "na" &&
              param.toLowerCase() !== "n.a."
          );
      }
    }

    const labTestCode =
      labTest?.labTestCode ||
      labTest?.partnerTestCode ||
      labTest?.id ||
      labTest?.curebayTestCode ||
      "";

    const cbTestCode = labTest?.cbTestCode || labTest?.curebayTestCode || "";

    return {
      labTestCode,
      cbTestCode,
      labTestName:
        labTest?.labTestName ||
        labTest?.testName ||
        labTest?.partnerTestName ||
        labTest?.displayName ||
        labTest?.name ||
        "",
      labTestType:
        labTest?.labTestType || labTest?.labType || labTest?.testType || "",
      isPackage: Boolean(labTest?.isPackage),
      isPostprandial: Boolean(labTest?.isPostprandial),
      amount: Number(
        labTest?.listPrice !== undefined && labTest?.listPrice !== null
          ? labTest?.listPrice
          : labTest?.amount || 0
      ),
      hospitalId: labTest?.diagnosticsCode || labTest?.labId || "",
      locationId: labTest?.locationCode || labTest?.locationId || "",
      sampleType: labTest?.sampleType || "",
      sampleColor: labTest?.sampleColor || "",
      vialType: labTest?.vialType || "",
      vialsColour: labTest?.vialsColour || labTest?.vialColor || "",
      vials: Number(labTest?.vials || labTest?.noOfVials || 0),
      sampleVolume: labTest?.sampleVolume || "",
      schedule: labTest?.schedule || "",
      testFor: labTest?.testFor || "",
      testCount: Number(labTest?.testCount || 0),
      testParameters,
      category: labTest?.category || "",
      method: labTest?.method || "",
      preTestInfo: labTest?.preTestInfo || "",
      howToRead: labTest?.howToRead || "",
      imageUrls: labTest?.imageUrls ?? null,
      icon: labTest?.icon || "",
      componentCovered: labTest?.componentCovered || "",
      intrResult: labTest?.intrResult || "",
      diagnosticsName: labTest?.diagnosticsName || labTest?.labName || "",
      labStartTime: labTest?.labStartTime || "",
      labEndTime: labTest?.labEndTime || "",
    };
  };

  const addToCart = async (labTest) => {
    console.log(labTest, "Adding to cart");

    const normalizedLabTest = normalizeLabTestData(labTest);

    if (
      cart.length > 0 &&
      locationid?.locationId &&
      normalizedLabTest.locationId &&
      normalizedLabTest.locationId !== locationid.locationId
    ) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Select this test from the same lab or replace the tests in your cart.",
        life: 3000,
      });
      return;
    }

    const isTestAlreadyInCart = cart.some(
      (item) => item.labTestName === normalizedLabTest.labTestName
    );

    if (isTestAlreadyInCart) {
      toast.current.show({
        severity: "warn",
        summary: "Duplicate Test",
        detail: "This test is already in your cart.",
        life: 3000,
      });
      return;
    }

    try {
      setHospitalName({
        labpartnername: normalizedLabTest?.diagnosticsName || "",
        labtestType: normalizedLabTest?.labTestType || "",
        labstartTime: normalizedLabTest?.labStartTime || "",
        labEndTime: normalizedLabTest?.labEndTime || "",
      });

      const payload = {
        patientId: scheduledata?.patientId,
        labTestCode: normalizedLabTest.labTestCode,
        cbTestCode: normalizedLabTest.cbTestCode,
        isPackage: normalizedLabTest.isPackage,
        isPostprandial: normalizedLabTest.isPostprandial,
        amount: normalizedLabTest.amount,
        hospitalId: normalizedLabTest.hospitalId,
        locationId: normalizedLabTest.locationId,
        labTestName: normalizedLabTest.labTestName,
        labTestType: normalizedLabTest.labTestType,
        sourceChannel: "B2C",
        sampleType: normalizedLabTest.sampleType,
        sampleColor: normalizedLabTest.sampleColor,
        vialType: normalizedLabTest.vialType,
        vialsColour: normalizedLabTest.vialsColour,
        vials: normalizedLabTest.vials,
        sampleVolume: normalizedLabTest.sampleVolume,
        schedule: normalizedLabTest.schedule,
        testFor: normalizedLabTest.testFor,
        testCount: normalizedLabTest.testCount,
        testParameters: normalizedLabTest.testParameters,
        category: normalizedLabTest.category,
        method: normalizedLabTest.method,
        preTestInfo: normalizedLabTest.preTestInfo,
        howToRead: normalizedLabTest.howToRead,
        imageUrls: normalizedLabTest.imageUrls,
        icon: normalizedLabTest.icon,
        componentCovered: normalizedLabTest.componentCovered,
        intrResult: normalizedLabTest.intrResult,
        ...(cartId ? { cartId } : {}),
      };

      const response = await http.post(
        `${process.env.REACT_APP_CARTURL}/cart/lab/add`,
        payload
      );

      if (response.status === 201) {
        toast.current.show({
          severity: "success",
          summary: "Added to Cart",
          detail: `${normalizedLabTest.labTestName} has been added to the cart.`,
        });
        setSuggestions([]);
        const newCartId =
          response?.data?.data?.cartId ||
          response?.data?.cartId ||
          cartId;

        if (newCartId) {
          setCartId(newCartId);
          await loadLabCartDetails(newCartId, { showToast: false });
        } else {
          await fetchCartList();
        }
      } else {
        toast.current.show({
          severity: "warn",
          summary: "Failed",
          detail: "Unable to add the lab test to the cart.",
        });
      }
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Something went wrong while adding to the cart.",
      });
    }
  };
  
console.log(hospitalName,"hospitalnnhhgg")
  const deleteCartItem = async (id) => {
    if (!cartId) {
      toast.current.show({
        severity: "error",
        summary: "Cart Missing",
        detail: "Cart information is missing. Please refresh and try again.",
        life: 3000,
      });
      return;
    }

    const payload = {
      cartId,
      id,
      patientId: scheduledata?.patientId,
    };

    try {
      const response = await http.delete(
        `${process.env.REACT_APP_CARTURL}/cart/lab/removeLab`,
        { data: payload }
      );

      if (response.status === 200) {
        toast.current.show({
          severity: "success",
          summary: "Item Deleted",
          detail: "The item has been successfully removed from the cart.",
        });
        await loadLabCartDetails(cartId, { showToast: false });
      } else {
        toast.current.show({
          severity: "warn",
          summary: "Failed",
          detail: "Unable to delete the item.",
        });
      }
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Something went wrong while deleting the item.",
      });
    }
  };
  const loadLabCartDetails = async (
    labCartId,
    { showToast = false } = {}
  ) => {
    if (!labCartId) {
      return;
    }

    try {
      const response = await http.get(
        `${process.env.REACT_APP_CARTURL}/cart/lab/details?cartId=${labCartId}&appsource=b2c_web`
      );

      const labtestCart =
        response?.data?.labtestCart ||
        response?.data?.data ||
        {};

      setCartId(labtestCart?.cartId || labCartId);

      const cartDataRaw =
        labtestCart?.patientLabTestsOrderDetailsList ||
        labtestCart?.labTestItems ||
        [];

      if (!Array.isArray(cartDataRaw) || cartDataRaw.length === 0) {
        setCart([]);
        setTotalCartSummary({ totalAmount: 0, paidAmount: 0 });
        setIsMembershipApplied(false);
        return;
      }

      const updatedCart = cartDataRaw.map((item) => {
        const originalAmount = Number(item?.amount ?? item?.totalAmount ?? 0);
        const paidAmount = Number(item?.totalAmount ?? item?.amount ?? 0);
        const discountAmount =
          Number(item?.discountAmount ?? originalAmount - paidAmount) || 0;

        return {
          id: item.id,
          labTestName: item?.labTestName,
          labName: item?.hospitalName || item?.drugCategory || "",
          originalAmount,
          paidAmount,
          discountAmount,
          labTestType: item?.labTestType,
        };
      });

      setCart(updatedCart);

      const totalAmount = Number(
        labtestCart?.totalAmount ?? labtestCart?.paidAmount ?? 0
      );
      const paidAmount = Number(
        labtestCart?.paidAmount ?? labtestCart?.totalAmount ?? 0
      );
      setTotalCartSummary({ totalAmount, paidAmount });

      const labTestTypes = updatedCart
        .map((item) => item.labTestType)
        .filter(Boolean);
      const isRadiology = labTestTypes.includes("Radiology");

      setHospitalName((prev) => ({
        labpartnername:
          labtestCart?.hospitalName || prev?.labpartnername || "",
        labtestType: labTestTypes[0] || prev?.labtestType || "",
        labstartTime: isRadiology
          ? labtestCart?.labStartTime ?? ""
          : prev?.labstartTime ?? "",
        labEndTime: isRadiology
          ? labtestCart?.labEndTime ?? ""
          : prev?.labEndTime ?? "",
      }));

      setLocationid({
        locationId:
          labtestCart?.locationId ||
          cartDataRaw?.[0]?.locationId ||
          "",
        hospitalname: labtestCart?.hospitalName || "",
      });

      const totalDiscount = updatedCart.reduce(
        (acc, item) => acc + Math.max(item.originalAmount - item.paidAmount, 0),
        0
      );
      setIsMembershipApplied(totalDiscount > 0);

      if (showToast && toast.current) {
        toast.current.show({
          severity: "info",
          summary: "Cart Updated",
          detail: "Cart has been updated with the latest items.",
        });
      }
    } catch (error) {
      console.error("Error loading lab cart details:", error);
      setCart([]);
      setTotalCartSummary({ totalAmount: 0, paidAmount: 0 });
      setIsMembershipApplied(false);
    }
  };

  const fetchCartList = async () => {
    try {
      const cartListResponse = await http.get(
        `${process.env.REACT_APP_CARTURL}/cart/common/cart-list/${scheduledata?.patientId}`
      );

      const carts = cartListResponse?.data?.data?.carts || [];
      const labCart =
        carts.find((cart) => {
          const type = (cart?.cartType ?? "").toString().toUpperCase();
          return type === "LAB" || type === "3";
        }) || carts.find((cart) => cart?.cartId);

      const fetchedCartId = labCart?.cartId;
      console.log(fetchedCartId, "Fetched Cart ID");
      setCartId(fetchedCartId);

      if (!fetchedCartId) {
        setCart([]);
        setIsMembershipApplied(false);
        setTotalCartSummary({ totalAmount: 0, paidAmount: 0 });
        setLocationid({ locationId: "", hospitalname: "" });
        return;
      }

      await loadLabCartDetails(fetchedCartId, { showToast: true });
    } catch (error) {
      console.error("Error fetching cart list:", error);
    }
  };

  const calculateTotalAmount = () => {
    return cart.reduce((total, item) => total + (item.originalAmount || 0), 0);
  };

  console.log(moment(selectedDate).format("YYYY-MM-DD"),selectedTime, "esdffggg");

  const submitCart = async () => {
if (!selectedDate && !selectedTime){
  toast.current.show({
    severity: "warn",
    summary: "preferdate and time",
    detail: "Please select preferred date and time",
    life: 3000,
  });
}
    try {
      const formattedPreferTime = formatPreferredTimeForApi(selectedTime);

      if (!cartId) {
        toast.current.show({
          severity: "error",
          summary: "Cart Missing",
          detail: "Cart information is missing. Please refresh the cart and try again.",
          life: 3000,
        });
        return;
      }

      if (!isAddressAdded || !selectedAddress) {
        toast.current.show({
          severity: "warn",
          summary: "Address Missing",
          detail: "Address is not added. Please add an address to proceed.",
          life: 3000,
        });
        return;
      }

      const pinCode = localStorage.getItem("selectedPinCode");
  
      if (!pinCode) {
        console.error("PinCode is not set. Please select an address.");
        toast.current.show({
          severity: "warn",
          summary: "Address Missing",
          detail: "Please select an address to proceed.",
          life: 3000,
        });
        return;
      }
  
      // Check service availability
      // const serviceCheckResponse = await http.get(
      //   `${process.env.REACT_APP_BASEURL}ServiceAvailability/checkDiagnoServiceAvailability?locationId=${locationid?.locationId}&pinCode=${pinCode}`
      // );
  
      // console.log(
      //   serviceCheckResponse?.data?.data,
      //   serviceCheckResponse?.data?.status,
      //   "fgthjn"
      // );
  
      // if (serviceCheckResponse?.data?.status === 400) {
      //   console.error(
      //     "Service not available for the selected pinCode:",
      //     pinCode
      //   );
      //   toast.current.show({
      //     severity: "warn",
      //     summary: "Service Unavailable",
      //     detail: `Service is not available for the selected PinCode: ${pinCode}`,
      //     life: 3000,
      //   });
      //   return;
      // }
  
      if (cart.length === 0) {
        console.error("No medicine is present in cart:");
        toast.warn(`Please Add Lab test in cart To Proceed`, {
          position: "top-center",
          autoClose: 3000,
        });
        return;
      }
  
      
      const payload = {
        preferDateTime: moment(selectedDate).format("YYYY-MM-DD 00:00:00") ,
        preferTime: formattedPreferTime,
        modifiedBy: userName,
      };
  
      const response1 = await http.put(
        `${process.env.REACT_APP_BASEURL}PatientLabTestsOrderDetails/update-preferred-time/${cartId}`,
        payload
      );
  
      console.log(response1, "Preferred time update response");
  
      if (response1?.status !== 200) {
        console.error("Failed to update preferred time.");
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Failed to update preferred time. Please try again.",
          life: 3000,
        });
        return; 
      }
  
     
      const response = await http.post(
        `${process.env.REACT_APP_BASEURL}newPatientMedicine/saveWhatsappUploadedPrescription?cartId=${cartId}&docName=${scheduledata?.photoName}&id=${scheduledata?.id}`
      );
  
      if (response) {
        const paymentPayload = {
          firstname: scheduledata?.firstName,
          email: scheduledata?.email,
          phone: scheduledata?.phoneNumber,
          productinfo: "cartpayment",
          cartid: cartId,
          patientId: scheduledata?.patientId,
          amount: totalCartSummary.paidAmount,
        };
  
        const paymentResponse = await http.post(
          `${process.env.REACT_APP_BASEURL}api/payment/generateAndSend`,
          paymentPayload
        );
  
        fetchCartList();
        closeFun();
  
        toast.current.show({
          severity: "success",
          summary: "Cart Updated",
          detail: "Cart has been updated successfully!",
          life: 3000,
        });
  
        console.log(paymentResponse, "Response from the second API");
      }
    } catch (error) {
      console.error("Error during cart submission:", error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail:
          "An error occurred while submitting the cart. Please try again later.",
        life: 3000,
      });
    }
  };
 
  


console.log(cart,"ftggh")
  

  return (
    <div className="container">
      <Toast ref={toast} />
      <div className="form-section">
        <label className="form-label">
          Check Diagnostic Service Availability
        </label>
        <div className="input-group">
          <InputText
            id="pincode"
            value={pincode}
            onChange={(e) => setPincode(e.target.value)}
            placeholder="Enter Pincode"
          />
          <Button
            label="Check Availability"
            icon="pi pi-check"
            className="button-primary"
            onClick={checkServiceAvailability}
          />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexDirection: "row",
          alignItems: "flex-start",
          padding: "5px",
          border: "1px solid #ddd",
          borderRadius: "8px",
          backgroundColor: isAddressAdded ? "#e6f7e6" : "#fbe9e9",
          color: isAddressAdded ? "#155724" : "#721c24",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          {isAddressAdded && selectedAddress ? (
            <div className="address-info">
              <strong>{selectedAddress.name}</strong>
              <p>
                {selectedAddress.address1} {selectedAddress.address2},{" "}
                {selectedAddress.city}, {selectedAddress.state} -{" "}
                {selectedAddress.pinCode}
              </p>
            </div>
          ) : (
            <label
              style={{
                fontWeight: "bold",
                fontSize: "16px",
              }}
            >
              Address is not Added
            </label>
          )}
        </div>
        <div
          style={{ display: "flex", flexDirection: "column", gap: "8px",padding:"10px" }}
          onClick={() => setIsVisible(true)}
        >
          <button
            style={{
              padding: "5px 10px",
              border: "none",
              borderRadius: "4px",
              color: "#e9e9ec",
              backgroundColor: "green",
              border: "none",
              cursor: "pointer",
            }}
          >
            Select/Add Address
          </button>
        </div>
      </div>
      <div className="form-section">
        <label className="form-label">Search for Lab Tests</label>
        <div className="input-group">
          <InputText
            value={searchText}
            onChange={(e) => handleSearchChange(e)}
            placeholder="Search for lab tests"
            disabled={!labCircle}
          />
          {/* <Button
        label="Search"
        icon="pi pi-search"
        className="button-primary"
        onClick={() => fetchSuggestions(searchText, labCircle)}
      /> */}
        </div>
        {suggestions.length > 0 && (
          <div className="suggestions-dropdown">
            {suggestions.map((suggestion, index) => (
              <div
                key={index}
                className="suggestion-item"
                onClick={() => addToCart(suggestion)}
              >
                <strong>
                  {suggestion?.displayName }
                </strong>
                <div>
                  {suggestion?.diagnosticsName}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <MembershipStatus
        patientId={scheduledata?.patientId}
        cartId={cartId}
        isMembershipApplied={isMembershipApplied}
        fetchCartList={fetchCartList}
        type={"lab"}
      />
      <div className="cart-section">
        {cart.length > 0 ? (
          <ul className="cart-list">
            {cart.map((item, index) => {
              const originalAmount = Number(item?.originalAmount ?? 0);
              const paidAmount = Number(item?.paidAmount ?? originalAmount);
              const hasDiscount = originalAmount > paidAmount;
              const discountAmount = hasDiscount
                ? originalAmount - paidAmount
                : 0;

              return (
              <li key={index} className="cart-item">
                <div>
                  <strong>{item.labTestName}</strong>
                  <p>{hospitalName?.labpartnername}</p>
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      marginTop: "10px",
                      alignItems: "baseline",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "16px",
                        color: hasDiscount ? "#999" : "#1a1a1a",
                        textDecoration: hasDiscount ? "line-through" : "none",
                        fontWeight: hasDiscount ? "normal" : "bold",
                      }}
                    >
                      ₹{formatCurrency(originalAmount)}
                    </span>
                    {hasDiscount && (
                      <>
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                            color: "#1a7f37",
                          }}
                        >
                          Paid: ₹{formatCurrency(paidAmount)}
                        </span>
                        {discountAmount > 0 && (
                          <span
                            style={{
                              fontSize: "14px",
                              color: "#555",
                            }}
                          >
                            Saved: ₹{formatCurrency(discountAmount)}
                          </span>
                        )}
                      </>
                    )}
                  </div>
                </div>
                <Button
                  icon="pi pi-trash"
                  className="button-danger"
                  onClick={() => deleteCartItem(item.id)}
                />
              </li>
            );
            })}
          </ul>
        ) : (
          <p>Your cart is empty.</p>
        )}

        {hospitalName?.labtestType  =="Pathology" ? 
  <div>
      {/* Date Selection */}
      <div className="date-selection">
        <button 
          onClick={() => setCurrentIndex((prev) => Math.max(0, prev - 1))}
          disabled={currentIndex === 0}
        >
          {"<"}
        </button>

        {dates.slice(currentIndex, currentIndex + 2).map((day, index) => (
          <button
            key={index}
            className={selectedDate.toDateString() === day.date.toDateString() ? "date-btn active" : "date-btn"}
            onClick={() => setSelectedDate(day.date)}
          >
            <strong>{day.label}</strong>
            <br />
            {day.displayDate}
          </button>
        ))}

        <button 
          onClick={() => setCurrentIndex((prev) => Math.min(dates.length - 2, prev + 1))}
          disabled={currentIndex >= dates.length - 2}
        >
          {">"}
        </button>
      </div>

      {/* Time Slot Selection */}
      <div className="time-slot-container">
        {generateTimeSlots(selectedDate)?.map((slot, index) => (
          <button
            key={index}
            className={`time-slot ${selectedTime === slot.time ? "active" : ""} ${
              slot.disabled ? "disabled" : ""
            }`}
            onClick={() => !slot.disabled && setSelectedTime(slot.time)}
            disabled={slot.disabled}
          >
            {slot.label}
          </button>
        ))}
      </div>

      <div className="selected-details">
        <h3>Selected Date & Time:</h3>
        <p><strong>Date:</strong> {selectedDate.toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric" })}</p>
        <p><strong>Time:</strong> {selectedTime ? formatPreferredTimeDisplay(selectedTime) : "Not selected"}</p>
      </div>
    </div>
    :
    <div>
    {/* Date Selection */}
    <div className="date-selection">
      <button 
        onClick={() => setCurrentIndex((prev) => Math.max(0, prev - 1))}
        disabled={currentIndex === 0}
      >
        {"<"}
      </button>
  
      {dates.slice(currentIndex, currentIndex + 2).map((day, index) => (
        <button
          key={index}
          className={`date-btn ${selectedDate.toDateString() === day.date.toDateString() ? "active" : ""}`}
          onClick={() => setSelectedDate(day.date)}
        >
          <strong>{day.label}</strong>
          <br />
          {day.displayDate}
        </button>
      ))}
  
      <button 
        onClick={() => setCurrentIndex((prev) => Math.min(dates.length - 2, prev + 1))}
        disabled={currentIndex >= dates.length - 2}
      >
        {">"}
      </button>
    </div>
  
    {/* Time Slot Selection */}
    <div className="time-slot-container">
      {generateTimeSlotsRadiology(selectedDate, hospitalName?.labstartTime, hospitalName?.labEndTime)?.map((slot, index) => (
        <button
          key={index}
          className={`time-slot ${selectedTime === slot.time ? "active" : ""} ${
            slot.disabled ? "disabled" : ""
          }`}
          onClick={() => !slot.disabled && setSelectedTime(slot.time)}
          disabled={slot.disabled}
        >
          {slot.label}
        </button>
      ))}
    </div>
  
    <div className="selected-details">
      <h3>Selected Date & Time:</h3>
      <p><strong>Date:</strong> {selectedDate.toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric" })}</p>
      <p><strong>Time:</strong> {selectedTime || "Not selected"}</p>
    </div>
  </div>
  
    }

        {/* Cart Summary Section */}
        <div
          style={{
            padding: "10px",
            border: "1px solid #ddd",
            borderRadius: "4px",
          }}
        >
          <h4
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              marginBottom: "10px",
            }}
          >
            Cart Summary
          </h4>
          <p style={{ marginBottom: "5px" }}>
            Subtotal:{" "}
            <span style={{ fontWeight: "bold" }}>
              ₹{formatCurrency(totalCartSummary.totalAmount)}
            </span>
          </p>
          <p style={{ marginBottom: "5px" }}>
            Discount:{" "}
            <span style={{ fontWeight: "bold" }}>
              ₹
              {formatCurrency(
                totalCartSummary.totalAmount - totalCartSummary.paidAmount
              )}
            </span>
          </p>
          <p style={{ marginBottom: "5px" }}>
            Paid Amount:{" "}
            <span style={{ fontWeight: "bold" }}>
              ₹{formatCurrency(totalCartSummary.paidAmount)}
            </span>
          </p>
        </div>

        <div style={{ marginTop: "5px", textAlign: "right" }}>
          <Button
            label="Submit"
            icon="pi pi-check"
            className={isAddressAdded && selectedDate && selectedTime && cart.length > 0 ? "button-success" : "btn-secondary"}
            onClick={submitCart}
            disabled={!(isAddressAdded && selectedDate && selectedTime && cart.length > 0)  }
          />
        </div>
      </div>

      <AddressBook
        patientId={scheduledata?.patientId}
        isVisible={isVisible}
        onHide={() => setIsVisible(false)}
        cartId={cartId}
        selectedAddress={selectedAddress}
        setSelectedAddress={setSelectedAddress}
        setIsAddressAdded={setIsAddressAdded}
      />
    </div>
  );
};

export default LabCartPage;
